import type { ReactNode } from 'react';

export interface CodeSnippetProps {
  children: ReactNode;
  className?: string;
}

export function CodeSnippet({
  children,
  className = 'p-4 bg-gray-100',
}: CodeSnippetProps) {
  return (
    <pre className={className}>
      <code className="font-monospace">{children}</code>
    </pre>
  );
}
